import React, { FC } from 'react';
import { Card } from '@material-ui/core';
import { useStyles } from './useStyles';

export const InvisibleCard: FC = ({ children }) => {
  const classes = useStyles();

  return <Card className={classes.root}>{children}</Card>;
};
